// src/services/api/business.js
import { apiClient } from './base';

/**
 * Get current business profile
 * @returns {Promise<Object>} Business data
 */
export const getBusinessProfile = async () => {
  try {
    const response = await apiClient.get('/business/profile');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update business profile
 * @param {FormData} businessData - Business update data (supports multipart/form-data)
 * @returns {Promise<Object>} Updated business data
 */
export const updateBusinessProfile = async (businessData) => {
  try {
    const response = await apiClient.put('/business/profile', businessData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get current business details (legacy)
 * @returns {Promise<Object>} Business data
 */
export const getBusiness = async () => {
  try {
    const response = await apiClient.get('/business');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update business profile (legacy)
 * @param {FormData} businessData - Business update data (supports multipart/form-data)
 * @returns {Promise<Object>} Updated business data
 */
export const updateBusiness = async (businessData) => {
  try {
    const response = await apiClient.put('/business', businessData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update business settings
 * @param {Object} settings - Settings to update
 * @returns {Promise<Object>} Updated business data
 */
export const updateBusinessSettings = async (settings) => {
  try {
    const response = await apiClient.put('/business/settings', settings);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update business theme
 * @param {string} theme - Theme to set
 * @returns {Promise<Object>} Updated business data
 */
export const updateBusinessTheme = async (theme) => {
  try {
    const response = await apiClient.put('/business/theme', { theme });
    return response.data;
  } catch (error) {
    throw error;
  }
};